<template>
	<b-overlay :show="LoaderStatus" rounded="sm" style="height: 90%">
		<div class="addeval-content-container">
			<!-- Edit Name -->
			<b-row
				><b-col>
					<div class="topDiv mt-3 relativeclass add-topic-parent">
						<label class="fieldsetStyle"
							>Evaluator Name &nbsp;<span class="asterik">*</span></label
						>
						<b-form-input
							class="inputField"
							id="input-1"
							type="text"
							v-model.trim="$v.eval.name.$model"
							v-on:keyup.enter="updateEvaluator()"
							placeholder="Enter Name"
							:class="{ error: $v.eval.name.$error }"
						>
						</b-form-input>
						<!-- Validations for Name -->
						<div
							class="validationicon"
							v-if="$v.eval.name.$dirty && !$v.eval.name.required"
							v-b-popover.hover.top.v-danger="{ content: 'Required' }"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							class="validationicon"
							v-if="!$v.eval.name.alpha && $v.eval.name.required"
							v-b-popover.hover.top.v-danger="{
								content: 'Please Enter a Valid Name',
							}"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							class="validationicon"
							v-if="!$v.eval.name.maxLength && $v.eval.name.required"
							v-b-popover.hover.top.v-danger="{
								content: 'Should not exceed 128 characters',
							}"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
					</div>
				</b-col>
			</b-row>
			<!-- Edit Mail -->
			<b-row
				><b-col>
					<div class="topDiv mt-3 relativeclass add-topic-parent">
						<label class="disable-fieldsetStyle"
							>Email Id &nbsp;<span class="asterik">*</span></label
						>
						<b-form-input
							class="disable-inputField cursor-disabled"
							id="input-1"
							type="email"
							placeholder="Enter Email"
							:disabled="!enableEditing"
							v-model.trim="$v.eval.email.$model"
							:class="{ error: $v.eval.email.$error }"
						>
						</b-form-input>
						<!-- Validations for Mail -->
						<div
							class="validationicon"
							v-if="$v.eval.email.$dirty && !$v.eval.email.required"
							v-b-popover.hover.top.v-danger="{ content: 'Required' }"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							class="validationicon"
							v-if="!$v.eval.email.maxLength"
							v-b-popover.hover.top.v-danger="{
								content: 'Should not execed 320 characters',
							}"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							class="ad-eval-validationicon"
							v-if="!$v.eval.email.localPartMaxLength"
							v-b-popover.hover.top.v-danger="{
								content:
									'Email should not exceed 64 characters before @ symbol',
							}"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							class="validationicon"
							v-if="
								!$v.eval.email.alpha ||
									($v.eval.email.required && !$v.eval.email.email)
							"
							v-b-popover.hover.top.v-danger="{
								content: 'Email is invalid',
							}"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
					</div>
				</b-col>
			</b-row>
			<!-- Edit Contact Number -->
			<b-row
				><b-col>
					<div class="topDiv mt-3 relativeclass add-topic-parent">
						<label class="fieldsetStyle"
							>Contact Number &nbsp;<span class="asterik">*</span></label
						>
						<b-form-input
							class="inputField"
							id="input-1"
							type="tel"
							@keydown="restrictToNumbers"
							placeholder="Enter Contact number"
							v-model.trim="$v.eval.phoneNumber.$model"
							v-on:keyup.enter="updateEvaluator()"
							:class="{ error: $v.eval.phoneNumber.$error }"
							maxlength="10"
						>
						</b-form-input>
						<!-- Validations for Contact Number -->
						<div
							class="validationicon"
							v-if="$v.eval.phoneNumber.$dirty && !$v.eval.phoneNumber.required"
							v-b-popover.hover.top.v-danger="{ content: 'Required' }"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							class="validationicon"
							v-if="!$v.eval.phoneNumber.alpha && $v.eval.phoneNumber.required"
							v-b-popover.hover.top.v-danger="{
								content: 'Invalid Number',
							}"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							class="validationicon"
							v-if="
								!$v.eval.phoneNumber.minLength &&
									!$v.eval.phoneNumber.maxLength &&
									$v.eval.phoneNumber.required
							"
							v-b-popover.hover.top.v-danger="{
								content: 'Should contain 10 digits',
							}"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
					</div>
				</b-col>
			</b-row>
			<!-- Edit Area of Expertise Tags -->
			<b-row>
				<b-col>
					<div
						class="topDiv mt-3"
						ref="exp"
						@click="expertiseFunction()"
						v-closable="{
							exclude: ['exp', 'expdropdown'],
							handler: 'hideexpertiseoptions',
						}"
					>
						<label class="fieldsetStyle"
							>Area Of Expertise&nbsp;<span class="asterik">*</span></label
						>
						<b-form-tags
							@input="expertiseFunction()"
							:tag-validator="tagValidatoraoe"
							invalid-tag-text="Duplicate tag(s)"
							class="inputField"
							:class="{
								tagsinputField:
									$v.aoeoptiontags.length > 0 && !$v.aoeoptiontags.$error,
								error: $v.aoeoptiontags.$error,
								reqd_add_1: $v.aoeoptiontags.$error,
								reqd_add_2: !$v.aoeoptiontags.$error,
							}"
							placeholder="Enter Area of Expertise"
							v-model="$v.aoeoptiontags.$model"
							remove-on-delete
						></b-form-tags>
						<!-- Validations for Area of Expertise -->
						<div
							style="position: absolute; right: 12px; top: 2px"
							v-if="$v.aoeoptiontags.$dirty && !$v.aoeoptiontags.required"
							v-b-popover.hover.top.v-danger="{ content: 'Required' }"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
					</div>
					<!-- Dropdown for Area of Expertise Tags-->
					<div v-if="aoe == true" class="qb-filter-modal2" ref="expdropdown">
						<div class="relativeclass aoeinput">
							<div class="aoesearchicon-pos">
								<img
									src="../../assets/icons/accesscontrol/inputsearch.svg"
									alt=""
								/>
							</div>
							<b-form-input
								class="inputField"
								type="text"
								placeholder="Search"
								v-model="searchexp"
							>
							</b-form-input>

							<div class="evaluatorDropdown-adjustment-class">
								<b-form-group v-if="searchexpres.length > 0">
									<b-form-checkbox
										class="qb-dropdown-option-sing pointer"
										size="sm"
										v-for="option in searchexpres"
										:key="option.expertise"
										:value="option.expertise"
										v-model="aoeoptiontags"
										name="flavour-4a"
									>
										{{ option.expertise }}
									</b-form-checkbox>
								</b-form-group>
								<div
									v-else-if="searchexpres.length == 0 && searchexp.length > 0"
									class="mt-2 d-flex align-items-center justify-content-center text-break"
									size="sm"
								>
									No matching results for "{{ searchexp }}".
								</div>
							</div>
						</div>
					</div>
				</b-col>
			</b-row>
			<!-- Edit Skill Tags -->
			<b-row>
				<b-col>
					<div
						class="topDiv mt-3"
						ref="skl"
						@click="skillFunction()"
						v-closable="{
							exclude: ['skl', 'skldropdown'],
							handler: 'hideskillOptions',
						}"
					>
						<label class="fieldsetStyle"
							>Skills&nbsp;<span class="asterik">*</span></label
						>
						<b-form-tags
							@input="skillFunction()"
							placeholder="Enter Skills"
							:tag-validator="tagValidator"
							invalid-tag-text="Duplicate tag(s)"
							class="inputField"
							:class="{
								tagsinputField:
									$v.skilloptionstag.length > 0 && !$v.skilloptionstag.$error,
								error: $v.skilloptionstag.$error,
								reqd_add_1: $v.skilloptionstag.$error,
								reqd_add_2: !$v.skilloptionstag.$error,
							}"
							v-model="$v.skilloptionstag.$model"
							remove-on-delete
						></b-form-tags>
						<!-- Validations for Skills -->
						<div
							style="position: absolute; right: 12px; top: 2px"
							v-if="$v.skilloptionstag.$dirty && !$v.skilloptionstag.required"
							v-b-popover.hover.top.v-danger="{ content: 'Required' }"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
					</div>
					<!-- Dropdown for Skill Tags-->
					<div
						v-if="skilltag == true"
						class="qb-filter-modal2"
						ref="skldropdown"
					>
						<div class="relativeclass aoeinput">
							<div class="aoesearchicon-pos">
								<img
									src="../../assets/icons/accesscontrol/inputsearch.svg"
									alt=""
								/>
							</div>
							<b-form-input
								class="inputField"
								type="text"
								placeholder="Search"
								v-model="searchskl"
							>
							</b-form-input>

							<div class="evaluatorDropdown-adjustment-class">
								<b-form-group v-if="searchsklres.length > 0">
									<b-form-checkbox
										class="qb-dropdown-option-sing pointer"
										size="sm"
										v-for="option in searchsklres"
										:key="option.skill"
										name="flavour-4a"
										:value="option.skill"
										v-model="skilloptionstag"
									>
										{{ option.skill }}
									</b-form-checkbox>
								</b-form-group>
								<div
									v-else-if="searchsklres.length == 0 && searchskl.length > 0"
									class="mt-2 d-flex align-items-center justify-content-center text-break"
									size="sm"
								>
									No matching results for "{{ searchskl }}".
								</div>
							</div>
						</div>
					</div>
				</b-col>
			</b-row>
		</div>
		<!-- Button to edit Evaluator -->
		<div class="twobtns d-flex align-items-center pointer">
			<div class="mr-3 cancelbtntext" @click="$emit('onEditEvaluator')">
				Cancel
			</div>
			<b-button class="addbtn pl-4 pr-4" @click="updateEvaluator()">
				Update
			</b-button>
		</div>
	</b-overlay>
</template>

<script>
import { getEvalList } from "../../utils/apiFunctions";
import toast from "../../views/mixin/toast";
import {
	searchExp,
	searchSkl,
	addEditEvaluator,
} from "../../controllers/evaluators/asynchronous";
import { getValidations } from "../../controllers/evaluators/validations";
import {
	restrictToNumbers,
	expertiseFunction,
	tagValidator,
	tagValidatoraoe,
	hideexpertiseoptions,
	skillFunction,
	hideskillOptions,
} from "../../controllers/evaluators/helpers";

export default {
	name: "EditEvaluator",

	mixins: [toast],
	data() {
		return {
			searchexp: "",
			searchskl: "",
			firstload: true,
			searchexpres: [],
			searchsklres: [],
			aoetags: {
				expertise: [],
			},
			skillstags: {
				skill: [],
			},
			searchskill: "",
			SearchExpertise: "",
			LoaderStatus: false,
			aoe: false,
			enableEditing: false,
			skilltag: false,
			eval: {
				portion: "Evaluator",
				aoearray: [],
				evaluatorID: "",
				skillarray: [],
				name: "",
				email: "",
				phoneNumber: "",
				regex: /^[6-9]\d{9}$/,
			},
			aoeoptiontags: [],
			skilloptionstag: [],
			phoneValid: true,
		};
	},
	props: {
		evaluatordata: Object,
	},
	validations() {
		return getValidations();
	},
	watch: {
		searchexp: function(newQ, oldQ) {
			if (newQ != oldQ) {
				searchExp(this);
			}
		},
		searchskl: function(newQ, oldQ) {
			if (newQ != oldQ) {
				searchSkl(this);
			}
		},
	},
	created() {
		this.getEvaluator();
		searchExp(this);
		searchSkl(this);
	},
	methods: {
		restrictToNumbers(evt) {
			restrictToNumbers(evt, this);
		},
		expertiseFunction() {
			expertiseFunction(this);
		},
		tagValidatoraoe(tag) {
			return tagValidatoraoe(tag, this);
		},
		hideexpertiseoptions() {
			hideexpertiseoptions(this);
		},
		skillFunction() {
			skillFunction(this);
		},
		hideskillOptions() {
			hideskillOptions(this);
		},
		tagValidator(tag) {
			return tagValidator(tag, this);
		},
		async getEvaluator() {
			this.LoaderStatus = true;
			try {
				const response = await getEvalList(this.evaluatordata.evaluatorID);
				this.eval = await response.data.data;
				for (let i of this.eval.areaOfExpertise) {
					this.aoeoptiontags.push(i.name);
				}
				for (let i of this.eval.skills) {
					this.skilloptionstag.push(i.name);
				}
				this.LoaderStatus = false;
			} catch (error) {
				this.LoaderStatus = false;
				throw new Error(`get evaluator Failed! status: ${error.status}`);
			}
		},
		async updateEvaluator() {
			addEditEvaluator("edit", this);
		},
	},
};
</script>
<style>
.b-form-tags input::placeholder {
	font-size: var(--size-13) !important;
	font-weight: var(--weight-R) !important;
	color: #6d6d6d !important;
	opacity: unset;
}

.inputField.form-control.error:focus {
	font-size: 12px;
}

.reqd_add_1 .b-form-tags-list .btn {
	margin-right: 25px;
}

.reqd_add_2 .b-form-tags-list .btn {
	margin-right: 0px;
}

.twobtns {
	position: absolute;
	bottom: 10px;
	right: 20px;
}

.b-form-tag > button.b-form-tag-remove {
	color: inherit;
	font-size: 180%;
	position: relative;
	top: 3px;
	margin-left: 1rem;
}

.close {
	opacity: unset;
}

.offerletter-container {
	background: #ffffff;
	border-radius: 8px;
	overflow: auto;
	height: calc(100vh - 140px);
	padding: 15px;
	box-shadow: 0px 0px 14px rgba(196, 196, 196, 0.5);
}

.badge {
	padding: 0.1em 1em;
	line-height: 2;
}

.badge-secondary {
	color: #72737e;
	font-size: 12px;
	font-weight: 400;
	background-color: #e7e8f5;
}

.aoeinput .form-control {
	padding: 0.375rem 1.3rem !important;
}

.qb-dropdown-diffy {
	background: #ffffff;
	border: 1px solid #ced4da;
	box-sizing: border-box;
	border-radius: 3px;
	color: #959494;
	font-size: var(--size-13);
	padding: 12px;
}

.aoesearchicon-pos {
	position: absolute;
	top: 5px;
	left: 5px;
}

.qb-dropdown-option-sing:nth-child(even) {
	background: #fdfdfd;
	padding: 10px 30px;
}

.qb-dropdown-option-sing:nth-child(odd) {
	background: #f4f4f4;
	padding: 10px 30px;
}

.templatecards-heading {
	font-weight: 600;
	font-size: 14px;
	color: #72738e;
	padding: 15px;
}

.text-muted {
	color: #dc3545 !important;
}

.topDiv > .disable-inputField {
	font-family: "Poppins", sans-serif;
	border: 1px solid #bbbbbb;
	border-radius: 3px !important;
	font-size: 12px;
	color: #6d6d6d;
	box-shadow: inset 0px 0px 4px rgb(0 0 0 / 25%);
	box-sizing: border-box;
}

.topDiv > .disable-fieldsetStyle {
	color: var(--bg-tertiary);
	background: #f4f4f4;
	position: absolute;
	left: 0.5vw;
	top: -9px;
	font-size: var(--size-10);
	line-height: 18px;
	z-index: 4;
	padding-left: 6px;
	padding-right: 4px;
}
</style>
